import { Grid } from '@mui/material';
import * as React from 'react';
import * as Redux from 'react-redux';
import { ModalComponent } from '../../widgets';
import BotonComponent from '../dashboard/components/BotonNuevo';
import {
  allActividadesExtcurAction,
  setActivoActividadesExtcurAction,
} from './ActividadesExtcurAction';
import FormActividadesExtcur from './components/FormActividadesExtcur';
import ListadoActividadesExtcur from './components/ListadoActividadesExtcur';

const ActividadesExtcurView = () => {
  const dispatch = Redux.useDispatch();

  const actividadesExtCurStore = Redux.useSelector(
    (state) => state.actividadesExtCur,
  );

  const [openModalForm, setOpenModalForm] = React.useState(false);

  return (
    <Grid container spacing={1}>
      <Grid item md={12}>
        <BotonComponent
          click={async () => {
            await setActivoActividadesExtcurAction(dispatch, null);
            setOpenModalForm(true);
          }}
          green
          mr={2}
          addIcon
        />
        <BotonComponent
          click={async () => {
            await setActivoActividadesExtcurAction(dispatch, null);
            await allActividadesExtcurAction(
              dispatch,
              actividadesExtCurStore.params,
            );
          }}
          disabled={
            actividadesExtCurStore.all.length === 0 ||
            actividadesExtCurStore.loadingAll
          }
          white
          refreshIcon
          text={
            actividadesExtCurStore.loadingAll ? 'Actualizando...' : 'Actualizar'
          }
        />
      </Grid>
      <Grid item md={12}>
        <ListadoActividadesExtcur setOpenModalForm={setOpenModalForm} />
      </Grid>
      <ModalComponent
        id="modalFormActividadesExtcur"
        title={`${
          actividadesExtCurStore.activo
            ? `Editar ${actividadesExtCurStore.activo.nombre}`
            : 'Nueva actividad extracurricular'
        }`}
        maxWidth="sm"
        open={openModalForm}
        onClose={() => setOpenModalForm(!openModalForm)}
      >
        <FormActividadesExtcur
          activo={actividadesExtCurStore.activo}
          setOpenModalForm={(val) => setOpenModalForm(val)}
        />
      </ModalComponent>
    </Grid>
  );
};

export default ActividadesExtcurView;
